import styled from 'styled-components'
import preloader from '../../../images/preloader.gif'

export const Loader = styled.div`
  height: 100vh;
  width: 100%;
  background: url('${preloader}') no-repeat center 30%;
  background-size: 50px;
`
